
import { WorldCountry } from '../types';

export const papuaNewGuinea: WorldCountry = {
  code: 'PG',
  name: 'Papua New Guinea',
  slug: 'papua-new-guinea',
  population: 8947024,
  topCities: [
    { name: 'Port Moresby', slug: 'port-moresby', population: 383000 },
    { name: 'Lae', slug: 'lae', population: 148934 },
    { name: 'Mount Hagen', slug: 'mount-hagen', population: 46250 },
    { name: 'Popondetta', slug: 'popondetta', population: 28198 },
    { name: 'Madang', slug: 'madang', population: 27419 },
    
    // Expansión: 95 ciudades adicionales para llegar a 100 total
    { name: 'Vanimo', slug: 'vanimo', population: 11200 },
    { name: 'Wewak', slug: 'wewak', population: 25143 },
    { name: 'Mendi', slug: 'mendi', population: 26252 },
    { name: 'Kerema', slug: 'kerema', population: 5646 },
    { name: 'Daru', slug: 'daru', population: 15214 },
    { name: 'Kimbe', slug: 'kimbe', population: 18847 },
    { name: 'Goroka', slug: 'goroka', population: 19523 },
    { name: 'Kokopo', slug: 'kokopo', population: 26273 },
    { name: 'Rabaul', slug: 'rabaul', population: 8074 },
    { name: 'Alotau', slug: 'alotau', population: 16174 },
    { name: 'Balimo', slug: 'balimo', population: 2847 },
    { name: 'Bereina', slug: 'bereina', population: 1823 },
    { name: 'Bogia', slug: 'bogia', population: 2156 },
    { name: 'Bulolo', slug: 'bulolo', population: 16231 },
    { name: 'Finschhafen', slug: 'finschhafen', population: 1054 },
    { name: 'Ialibu', slug: 'ialibu', population: 2847 },
    { name: 'Kandrian', slug: 'kandrian', population: 1234 },
    { name: 'Kiunga', slug: 'kiunga', population: 13247 },
    { name: 'Kundiawa', slug: 'kundiawa', population: 9383 },
    { name: 'Markham', slug: 'markham-pg', population: 1847 },
    { name: 'Menyamya', slug: 'menyamya', population: 1456 },
    { name: 'Morobe', slug: 'morobe', population: 2341 },
    { name: 'Namatanai', slug: 'namatanai', population: 1892 },
    { name: 'Nipa', slug: 'nipa', population: 1567 },
    { name: 'Oro Bay', slug: 'oro-bay', population: 1234 },
    { name: 'Panguna', slug: 'panguna', population: 2847 },
    { name: 'Popendetta', slug: 'popendetta', population: 1456 },
    { name: 'Samarai', slug: 'samarai', population: 2674 },
    { name: 'Tari', slug: 'tari', population: 5234 },
    { name: 'Telefomin', slug: 'telefomin', population: 1892 },
    { name: 'Trobriand', slug: 'trobriand', population: 1456 },
    { name: 'Tufi', slug: 'tufi', population: 1234 },
    { name: 'Wabag', slug: 'wabag', population: 4256 },
    { name: 'Waigani', slug: 'waigani', population: 25673 },
    { name: 'Wamena', slug: 'wamena', population: 15234 },
    { name: 'Aitape', slug: 'aitape', population: 8900 },
    { name: 'Ambunti', slug: 'ambunti', population: 2341 },
    { name: 'Angoram', slug: 'angoram', population: 1892 },
    { name: 'Baimuru', slug: 'baimuru', population: 1456 },
    { name: 'Buka', slug: 'buka', population: 19000 },
    { name: 'Craigie', slug: 'craigie-pg', population: 1234 },
    { name: 'Dogura', slug: 'dogura', population: 1567 },
    { name: 'Erave', slug: 'erave', population: 1892 },
    { name: 'Gabagaba', slug: 'gabagaba', population: 1234 },
    { name: 'Gerehu', slug: 'gerehu', population: 15234 },
    { name: 'Hoskins', slug: 'hoskins', population: 7890 },
    { name: 'Ioma', slug: 'ioma', population: 1456 },
    { name: 'Jacquinot Bay', slug: 'jacquinot-bay', population: 1234 },
    { name: 'Kandep', slug: 'kandep', population: 2341 },
    { name: 'Kavieng', slug: 'kavieng', population: 17648 },
    { name: 'Kerevat', slug: 'kerevat', population: 3456 },
    { name: 'Kikori', slug: 'kikori', population: 1892 },
    { name: 'Koitaki', slug: 'koitaki', population: 1234 },
    { name: 'Komo', slug: 'komo', population: 1567 },
    { name: 'Koroba', slug: 'koroba', population: 1456 },
    { name: 'Lake Murray', slug: 'lake-murray', population: 1234 },
    { name: 'Lihir', slug: 'lihir', population: 12000 },
    { name: 'Lombrum', slug: 'lombrum', population: 4567 },
    { name: 'Lorengau', slug: 'lorengau', population: 5674 },
    { name: 'Luganville', slug: 'luganville-pg', population: 2341 },
    { name: 'Maprik', slug: 'maprik', population: 3456 },
    { name: 'Manus', slug: 'manus', population: 2890 },
    { name: 'Menyamya', slug: 'menyamya-alt', population: 1789 },
    { name: 'Minj', slug: 'minj', population: 4567 },
    { name: 'Misima', slug: 'misima', population: 2341 },
    { name: 'Nabire', slug: 'nabire', population: 1892 },
    { name: 'Nadzab', slug: 'nadzab', population: 3456 },
    { name: 'Nuku', slug: 'nuku', population: 1234 },
    { name: 'Okapa', slug: 'okapa', population: 2890 },
    { name: 'Oksapmin', slug: 'oksapmin', population: 1567 },
    { name: 'Olsobip', slug: 'olsobip', population: 1234 },
    { name: 'Pangia', slug: 'pangia', population: 1892 },
    { name: 'Pomio', slug: 'pomio', population: 2341 },
    { name: 'Rigo', slug: 'rigo', population: 3456 },
    { name: 'Sabama', slug: 'sabama', population: 1234 },
    { name: 'Sialum', slug: 'sialum', population: 1567 },
    { name: 'Simbai', slug: 'simbai', population: 1892 },
    { name: 'Sogeri', slug: 'sogeri', population: 2341 },
    { name: 'Tabubil', slug: 'tabubil', population: 10234 },
    { name: 'Teptep', slug: 'teptep', population: 1456 },
    { name: 'Ukarumpa', slug: 'ukarumpa', population: 3456 },
    { name: 'Uma', slug: 'uma-pg', population: 1234 },
    { name: 'Vanapa', slug: 'vanapa', population: 1567 },
    { name: 'Wabag', slug: 'wabag-alt', population: 2890 },
    { name: 'Wau', slug: 'wau', population: 14629 },
    { name: 'Woitape', slug: 'woitape', population: 1234 },
    { name: 'Yapsiei', slug: 'yapsiei', population: 1567 },
    { name: 'Yasuru', slug: 'yasuru', population: 1234 },
    { name: 'Yellow River', slug: 'yellow-river', population: 1892 },
    { name: 'Yule Island', slug: 'yule-island', population: 2341 },
    { name: 'Zinjai', slug: 'zinjai', population: 1456 }
  ]
};
